import { IRequest, RequestStatus, RequestType, ServiceType, SurgeryStatus } from "./types";

export type LabStatus = RequestStatus.COMPLETED | RequestStatus.CANCELED | RequestStatus.PENDING_PAYMENT | RequestStatus.PAYMENT_COMPLETED;
export const labStatusValues: LabStatus[] = [
    RequestStatus.COMPLETED,
    RequestStatus.CANCELED,
    RequestStatus.PENDING_PAYMENT,
    RequestStatus.PAYMENT_COMPLETED
];

/** SHER-488: pharmacy stock-request workflow — not lab/billing statuses. */
export type PharmacyStatus =
    | RequestStatus.PENDING_APPROVAL
    | RequestStatus.IN_PROGRESS
    | RequestStatus.COMPLETED
    | RequestStatus.DENIED
    | RequestStatus.CANCELED;

export const pharmacyStatusValues: PharmacyStatus[] = [
    RequestStatus.PENDING_APPROVAL,
    RequestStatus.IN_PROGRESS,
    RequestStatus.COMPLETED,
    RequestStatus.DENIED,
    RequestStatus.CANCELED,
];

export const surgeryStatusValues: SurgeryStatus[] = [
    RequestStatus.ANESTHESIOLOGIST_ACCEPTED,
    RequestStatus.PAYMENT_COMPLETED,
    RequestStatus.READY_FOR_SURGERY,
    RequestStatus.COMPLETED,
    RequestStatus.PENDING_ANESTHESIOLOGIST,
    RequestStatus.PENDING_PAYMENT,
    RequestStatus.PENDING_PURCHASE_SURGERY_PROTHESIS,
    RequestStatus.ANESTHESIOLOGIST_REJECTED,
    RequestStatus.CHECKED_IN,
    RequestStatus.CANCELED
];


export function getRequestStatusName(status: RequestStatus): string {
    return RequestStatus[status];
}




/**
 * Calculates the total days for a request based on its type
 * @param request The request object
 * @returns The calculated number of days
 */
export const calculateTotalDays = (request: IRequest, requestServiceType:ServiceType): string => {

    if(request.completedAt){
        return "-";
    }
    let referenceDate = "createdAt";
        
    // Type-specific calculations
    switch (requestServiceType) {
        case ServiceType.SURGERY:
        referenceDate = "readyForSurgeryAt"
    }
    if(request[referenceDate as keyof IRequest]){
        const date = new Date(request[referenceDate as keyof IRequest]).getTime();
        const todayDate = new Date().getTime();
        const totalDays = Math.round((todayDate - date) / (1000 * 60 * 60 * 24));
        return totalDays.toString();
    }
    return "-";
}; 